module.exports = __webpack_public_path__ + "img/prize-03.a7000497.png";